import React from "react";
import "./SortBy.scss";

export default ({ items, currentRefinement, refine }) => {
  if (!items) {
    return null;
  }

  const currentRefinementItem = items.find(i => i.value === currentRefinement);
  const currentRefinementLabel = currentRefinementItem
    ? currentRefinementItem.label
    : "";

  return (
    <div className="sort-by">
      <label htmlFor="sort-by">Sort&nbsp;by:&nbsp;</label>
      <div className="ow-dropdown ow-dropdown--borderless fix-added-div">
        <span className="ow-dropdown__selected">{currentRefinementLabel}</span>
        <select
          id="sort-by"
          style={{ opacity: 0 }}
          onChange={({ target }) => { refine(target.value); }}
        >
          {items.map(i => (
            <option key={i.value} value={i.value}>
              {i.label}
            </option>
          ))}
        </select>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="5px" viewBox="0 0 10 5"><path fill="#005bab" d="M0,0l5,5l5-5H0z"></path></svg>
    </div>
  );
};
